/* eslint-disable @typescript-eslint/no-explicit-any */

type ResponseConstructorProps = {
  status: number;
  code: string;
  message?: string;
  data?: any;
  errorData?: any;
};

class Response {
  status: number;
  code: string;
  message?: string;
  data?: any;
  errorData?: any;

  constructor({
    status,
    code,
    message,
    data,
    errorData,
  }: ResponseConstructorProps) {
    this.status = status;
    this.code = code;
    this.message = message;
    this.data = data;
    this.errorData = errorData;
  }

  static fromJson(json: any) {
    return new Response({
      status: json.status ?? 500,
      code: json.code ?? "general/error",
      message: json.message,
      data: json.data,
    });
  }

  static success(data?: any) {
    return new Response({
      status: 200,
      code: "general/success",
      data,
    });
  }

 get success() {
    return this.status >= 200 && this.status < 300;
  }

  get statusCode() {
    return this.status;
  }

  withData(data: any) {
    this.data = data;
    return this;
  }

  withMessage(message: string, stringify = false) {
    this.message = stringify ? JSON.stringify(message) : message;
    return this;
  }

  toJson() {
    const res = { status: this.status, code: this.code } as any;
    if (this.message !== undefined) res.message = this.message;
    if (this.data !== undefined) {
      if (typeof this.data === "object") res.data = this.data;
      else res.data = this.data.toString();
    }
    return res;
  }

  toError() {
    const error = new Error(this.message || "An error occurred");
    error.name = this.code;
    return error;
  }

  withErrorData(errorData: any) {
    if (typeof errorData === "object") errorData = JSON.stringify(errorData);
    else errorData = errorData.toString();
    this.errorData = errorData;
    return this;
  }
}

export { Response };
